import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, makeStyles, List, ListItem, ListItemText, Typography, Box } from '@material-ui/core'
import React from 'react'
import SystemModelUpdateAlertContent from '../../molecules/PromptModal/SystemModelUpdateAlertContent'

const useStyles = makeStyles(() => ({
    alertContainer: {
        minWidth: '960px'
    },
    textCapitalise:{
        textTransform: 'capitalize'
    } 
}))



export default function AlertDialog({
    open,
    title,
    content,
    proceedText='Continue',
    proceedColor='primary',
    abortText='Cancel',
    abortColor='secondary',
    onClose,
    onProceed,
    isLoading,
    id,
    hideDialogActions=false,
    className,
    hideAbort
}) {

    const styles = useStyles();

  return (
    <Dialog
        open={open}
        disablePortal
        style={{zIndex: 7000}}
        classes={{
            paper: styles.alertContainer
        }}
        id={id || 'alert-dialog'}
    >
        <DialogTitle>{title}</DialogTitle>
        <Divider />
        <DialogContent >
            <DialogContentText style={{"white-space":" pre-line"}}> 
                {typeof content === 'string' ? (content) :   <SystemModelUpdateAlertContent data={content} /> } 
            </DialogContentText>
        </DialogContent>
        <Divider />
        {hideDialogActions === false && <DialogActions>
            {
                !hideAbort &&
                <Button variant='contained' onClick={onClose} style={{textTransform: 'capitalize'}}>{abortText} </Button>
            }
            <Button variant='contained' color={proceedColor} onClick={onProceed} style={{textTransform: 'capitalize'}} disabled={isLoading}>{proceedText} </Button>
        </DialogActions>}
    </Dialog>
  )
}
